import {
  IAgoraRTCRemoteUser,
  RemoteAudioTrack,
  useRemoteUserTrack,
} from "agora-rtc-react";
import { MeetStyleVideoPlayer } from "../MeetStyleVideoPlayer";

interface MeetStyleRemoteVideoProps {
  user: IAgoraRTCRemoteUser;
  playVideo: boolean;
}

/**
 * Inscreve no vídeo/áudio remoto (como RemoteUser) e reproduz com fit "contain".
 */
export const MeetStyleRemoteVideo = ({
  user,
  playVideo,
}: MeetStyleRemoteVideoProps) => {
  const { track: videoTrack } = useRemoteUserTrack(user, "video");
  const { track: audioTrack } = useRemoteUserTrack(user, "audio");

  return (
    <>
      <MeetStyleVideoPlayer track={videoTrack} play={playVideo} />
      {audioTrack ? <RemoteAudioTrack track={audioTrack} play /> : null}
    </>
  );
};

export default MeetStyleRemoteVideo;
